module.exports = __webpack_public_path__ + "static/img/product_make.5a4d765.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/product_make.png
// module id = 2CJC
// module chunks = 0